var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircledotIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "10px",
    height: "10px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -197 -39 )"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 202 39  C 204.8 39  207 41.2  207 44  C 207 46.8  204.8 49  202 49  C 199.2 49  197 46.8  197 44  C 197 41.2  199.2 39  202 39  Z ",
    fillRule: "nonzero",
    fill: "#ffffff",
    stroke: "none",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 202 39.5  C 204.52 39.5  206.5 41.48  206.5 44  C 206.5 46.52  204.52 48.5  202 48.5  C 199.48 48.5  197.5 46.52  197.5 44  C 197.5 41.48  199.48 39.5  202 39.5  Z ",
    strokeWidth: 1,
    stroke: "#797979",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircledotIcon);
export default __webpack_public_path__ + "static/media/circledot_icon.f378728a5f4f299f3ba47ce6896badc8.svg";
export { ForwardRef as ReactComponent };